export class NextConfig {
  public static config = {
    layout: 'vertical', // vertical, horizontal
    subLayout: '', // horizontal-2
    collapseMenu: true,
    layoutType: 'menu-dark', // menu-dark, menu-light, dark
    headerBackColor: 'header-info', // header-default, header-blue, header-red, header-purple, header-info, header-dark
    navBrandColor: 'brand-info', // brand-default, brand-blue, brand-red, brand-purple, brand-info, brand-dark
    rtlLayout: false,
    navFixedLayout: false,
    headerFixedLayout: true,
    boxLayout: false,
  };
}
